import { memo } from "react";

import { isEmptyArray } from "@/lib/chillnn/is-empty-array";

import { FeatureIslandMainWithBackGround } from "@/components/features/_layouts";

import { ArticleCard } from "./components/article-card";

import type { ReferenceArticle } from "./types";

export type { ReferenceArticle };

type Props = {
	articles: ReferenceArticle[];
};

export const ReferenceArticles = memo(({ articles }: Props) => {
	if (isEmptyArray(articles)) {
		return null;
	}

	return (
		<FeatureIslandMainWithBackGround>
			<div className="max-w-screen-screen relative  p-4">
				<h3 className="mb-4 text-lg font-semibold">参考記事</h3>
				<div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
					{articles.map((article, index) => (
						<ArticleCard key={`article-${index}`} article={article} />
					))}
				</div>
			</div>
		</FeatureIslandMainWithBackGround>
	);
});

ReferenceArticles.displayName = "ReferenceArticles";
